import React, { useState, useContext, useEffect } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { months } from '../global';
import API from '../API';
import { AdminOpenMonthStatusResponse } from '../../../backend/src/api/dto';

interface Props {
    confirm: Function | null,
    year: number
    month: number
}


function AdminOpenMonth({ confirm, year, month }: Props) {

    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const [data, setData] = useState<AdminOpenMonthStatusResponse[]>([])


    useEffect(() => {
        API.openMonthStatus(year, month).then(data => {
            setData(data)
        })
    }, [])


    const modalButtons = [
        {
            text: 'Potvrdiť',
            icon: 'check',
            onClick: () => {
                if (!confirm) {
                    return
                }
                setLoading(true);
                confirm().then(() => {
                    setLoading(false);
                    setApiResult({
                        status: true,
                    })
                    closeModal(null);
                }).catch((err: any) => {
                    setLoading(false);
                    setApiResult(err)
                })
            },
            style: 'primary'
        }, {
            text: 'Zrušiť',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    return (


        <div>
            <Modal
                buttons={modalButtons}
                title="Potvrdiť otvorenie mesiaca"
                errorObject={apiResult}
                disableAllButtons={loading}
            >

                <div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>Mesiac</td>
                                <td>{
                                    months.find((item, index) => (index + 1) === month)
                                }</td>
                            </tr>
                        </tbody>
                    </table>

                    <table className="table table-bordered mt-5">
                        <tbody>
                            <tr>
                                <th>Meno</th>
                                <th>Stav</th>
                            </tr>
                            {
                                data.map(entry => {
                                    return (
                                        <tr>
                                            <td>{entry.name} {entry.surname}</td>
                                            <td>{entry.opened ? <span className="badge text-bg-success">Už otvorený</span> : <span className="badge text-bg-warning">Otvorí sa</span>}</td>
                                        </tr>
                                    )
                                })

                            }

                        </tbody>
                    </table>

                </div>


            </Modal>
        </div>


    )

}

export default AdminOpenMonth
